const allowedFormats = (formats) => formats.map((format) => {
    const parts = format.split("/");
    return parts[parts.length - 1].toUpperCase();
}).join(", ");

export default allowedFormats;
